export default {
    formId: 'editParameterForm', //'editParameterForm',
    formField: {
     
      e_llegadas_tarde: {
        name: 'e_llegadas_tarde',
        label: 'Minutos llegada tarde*',
        requiredErrorMsg: 'Minutos llegada tarde es requerido.'
      },
      e_salidas_tarde: {
        name: 'e_salidas_tarde',
        label: 'Minutos salida tarde*',
        requiredErrorMsg: 'Minutos salida tarde es requerido.'
      },
      e_salario_minimo: {
        name: 'e_salario_minimo',
        label: 'Salario minimo*',
        requiredErrorMsg: 'Salario minimo es requerido.'
      },
      e_auxilio_transporte: {
        name: 'e_auxilio_transporte',
        label: 'Auxilio transporte*',
        requiredErrorMsg: 'Auxilio transporte es requerido.'
      },
      e_interes_cesantias: {
        name: 'e_interes_cesantias',
        label: 'Intereses cesantias*',
        requiredErrorMsg: 'Intereses cesantias es requerido.'
      },
      e_year: {
        name: 'e_year',
        label: 'Año*',
        requiredErrorMsg: 'Año es requerido.'
      }

    }
};
  